import { Button, Form, Input, message, Popover } from 'antd';
import React, { useState } from 'react';
import { DislikeFilled, DislikeOutlined } from '@ant-design/icons';
import FeedbackTags from './FeedbackTags';

export interface DislikeFeedbackProps {
  msg: any;
  activeColor: string;
  onSubmit: (v: any) => Promise<boolean>;
}

export const DislikeFeedback: React.FC<DislikeFeedbackProps> = ({ msg, activeColor, onSubmit }) => {
  const [form] = Form.useForm();
  const [showFeedback, setShowFeedback] = useState(false);
  return (
    <Popover
      trigger={['click']}
      open={showFeedback}
      onOpenChange={(v) => {
        const isLike = msg.isLike ?? 0;
        if (v && isLike !== 0) {
          message.warning('已收到您的反馈，无需重复提交');
          return;
        }
        if (v) {
          form.resetFields();
        }
        setShowFeedback(v);
      }}
      title={(
        <div>
          <div>抱歉，未能满足您的需求</div>
          <div style={{ color: '#999', fontWeight: 'normal', marginBottom: 12 }}>
            为提升您的使用体验，请告诉我们不足的方向
          </div>
        </div>
      )}
      content={(
        <div>
          <Form form={form}>
            <Form.Item name="feedbackTags" style={{ marginBottom: 12 }}>
              <FeedbackTags />
            </Form.Item>
            <Form.Item name="feedbackDescription" style={{ marginBottom: 12 }}>
              <Input.TextArea rows={4} placeholder="欢迎说说你的想法" />
            </Form.Item>
            <Form.Item dependencies={['feedbackTags', 'feedbackDescription']} noStyle>
              {({ getFieldValue }) => {
                const feedbackTags = getFieldValue('feedbackTags') || [];
                const feedbackDescription = getFieldValue('feedbackDescription');
                const disabled = !feedbackTags.length && !feedbackDescription;
                return (
                  <Button
                    type="primary"
                    block
                    disabled={disabled}
                    onClick={async () => {
                      const formData = await form.validateFields();
                      const res = await onSubmit(formData);
                      if (res) {
                        setShowFeedback(false);
                      }
                    }}
                  >
                    提交反馈
                  </Button>
                );
              }}
            </Form.Item>
          </Form>
        </div>
      )}
    >
      {(msg.raw?.isLike || msg.isLike) === -1
        ? (
            <Button
              type="text"
              size="small"
              icon={<DislikeFilled style={{ color: activeColor }} />}
            />
        )
        : (
            <Button
              type="text"
              size="small"
              icon={<DislikeOutlined style={{ color: '#949494' }} />}
            />
        )}
    </Popover>
  );
};

export default DislikeFeedback;
